import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 
 */
export class HomePageControllerSvr {
  constructor() {
    this.baseurl = 'HomePageControllerSvr.assx/';
  }

  /**
   * 检查考评统计
   * token:String
   */
  CheckAndReview(token) {
    return request.post(this.baseurl + 'CheckAndReview', Qs.stringify({
      token: token
    }));
  }

  /**
   * 投票按使用统计
   * token:String
   */
  VoteStatistics(token) {
    return request.post(this.baseurl + 'VoteStatistics', Qs.stringify({
      token: token
    }));
  }

  /**
   * 满意度调查统计
   * token:String
   */
  SurveyStatistics(token) {
    return request.post(this.baseurl + 'SurveyStatistics', Qs.stringify({
      token: token
    }));
  }

  /**
   * 投诉统计
   * token:String
   */
  ComplaintStatistics(token) {
    return request.post(this.baseurl + 'ComplaintStatistics', Qs.stringify({
      token: token
    }));
  }

  /**
   * 全市投票按时间统计
   * token:String, options:int
   */
  CityVoteStatistics(token, options) {
    return request.post(this.baseurl + 'CityVoteStatistics', Qs.stringify({
      token: token,
      options: options
    }));
  }

  /**
   * 公司下小区投诉统计
   * token:String
   */
  CompanyComplaintStatistics(token) {
    return request.post(this.baseurl + 'CompanyComplaintStatistics', Qs.stringify({
      token: token
    }));
  }

  /**
   * 获取首页小区信息列表
   * token:String
   */
  GetAreaInfo(token,startIndex,maxSize) {
    return request.post(this.baseurl + 'GetAreaInfo', Qs.stringify({
      token: token,
      startIndex:startIndex,
      maxSize:maxSize
    }));
  }

  /**
   * 全市企业信用统计
   * token:String
   */
  CityCompanyStatistics(token) {
    return request.post(this.baseurl + 'CityCompanyStatistics', Qs.stringify({
      token: token
    }));
  }
  /**
   * 
   * 检查考评细节详情
   * @param {String} token 
   * @param {*String} checkAndReviewId 
   */
  getCheckAndReviewDetail(token,checkAndReviewId,keyword){
    return request.post(this.baseurl + 'getCheckAndReviewDetail', Qs.stringify({
      token: token,
      checkAndReviewId:checkAndReviewId,
      keyword:keyword
    }));
  }
  /**
   * 修改考评细节详情
   * token:String, checkAndReviewId:String, totalScore:String, eaAreaCode:String
   */
  updateCheckAndReviewDetail(token, checkAndReviewId, totalScore, eaAreaCode){
      return request.post(this.baseurl + 'updateCheckAndReviewDetail', Qs.stringify({ token:token, checkAndReviewId:checkAndReviewId, totalScore:totalScore, eaAreaCode:eaAreaCode }));
  }
  /**
   * 修改用户默认身份为当前选中的身份
   * token:String, roleId:String
   */
  updateDefaultRole(token, roleId){
      return request.post(this.baseurl + 'updateDefaultRole', Qs.stringify({ token:token, roleId:roleId }));
  }

  
  /**
   * 获取首页建设单位信息列表
   * token:String
   */
  getAreaList(token,startIndex,maxSize) {
    return request.post(this.baseurl + 'getAreaList', Qs.stringify({
      token: token,
      startIndex:startIndex,
      maxSize:maxSize
    }));
  }
}